import merchant from './merchants'
import product from './products'
import story from './stories'
import collections from './collections'
import sms from './sms'
import share from './share'

export default {
  merchant, product, story, collections, sms, share,
}
